import { BuildAction } from '../enums';

export const BuildActions = [
  { name: 'None', value: BuildAction.None },
  { name: 'Api Redirect', value: BuildAction.ApiRedirect },
  { name: 'Force Update', value: BuildAction.ForceUpdate },
];
